import { ListaIdPessoa } from './../shared/models/listaIdPessoa.model';
import { async, flushMicrotasks } from '@angular/core/testing';
import { ViewModelGridProcessoInstitutosLegais } from './../shared/models/ViewModelGridProcessoInstitutosLegais.model';
import { Component, OnInit, ViewChild } from "@angular/core";
import { MatPaginator } from "@angular/material/paginator";
import { MatTableDataSource } from "@angular/material/table";
import { SelectionModel } from '@angular/cdk/collections';
import { Router } from "@angular/router";
import { ViewModelFiltraProcessoInstitutosLegais } from '../shared/models/ViewModelFiltraProcessoInstitutosLegais.model';
import { ProcessoService } from '../shared/services/processo.service';
import { EsteiraService } from '../shared/services/esteira.service';
import { PlanoService } from '../shared/services/plano.service';
import { WebProcessoControleService } from '../shared/services/webProcessoControle.service';
import { MatSnackBar, MatSort } from '@angular/material';
import { LoginStore } from '../shared/store/login.store';
import { ViewModelFiltraProcesso } from '../shared/models/ViewModelFiltraProcesso.model';
import { Processo } from '../shared/models/processo.model';
import { Esteira } from '../shared/models/esteira.model';
import { Plano } from '../shared/models/plano.model';
import { Filtro } from '../shared/models/filtro.model';
import { WebProcessoInstitutosLegaisService } from '../shared/services/webProcessoInstitutosLegais.service';
import { ViewModelFinalizaProcesso } from '../shared/models/ViewModelFinalizaProcesso.model';
import { environment } from 'environments/environment';
import { EnviarEmailInstitutosLegaisService } from '../shared/services/enviar-email-institutos-legais.service';

@Component({
    selector: "app-enviar-email",
    templateUrl: "./enviar-email.component.html",
    styleUrls: ["./enviar-email.component.scss"],
})
export class EnviarEmailComponent implements OnInit {
    [x: string]: any;
    @ViewChild(MatPaginator, { static: false }) paginator: MatPaginator;
    @ViewChild(MatSort, { static: false }) sort: MatSort;
    lista_Processo: Processo[] = [];
    lista_Esteira: Esteira[] = [];
    lista_Plano: Plano[] = [];
    displayedColumns: string[] = ['select', 'nrCpf', 'nomePessoa', 'dtDesligamento', 'nrMatricula', 'nomePlano'];
    selection = new SelectionModel<any>(true, []);
    dataSource = new MatTableDataSource<any>();
    loading = false;
    viewModelFiltraProcessoInstitutosLegais: ViewModelFiltraProcessoInstitutosLegais = new ViewModelFiltraProcessoInstitutosLegais();
    viewModelGridProcessoInstitutosLegais: ViewModelGridProcessoInstitutosLegais = new ViewModelGridProcessoInstitutosLegais();
    selectedProcesso: number;
    selectedMatricula: number;
    selectedPlano: number;
    selectedOrderBy: number;
    dataInicio: string;
    dataFim: string;
    idPessoaLogada: number;
    PostFiltro: ViewModelFiltraProcesso = new ViewModelFiltraProcesso();
    GridProcessoInstitutosLegais: ViewModelGridProcessoInstitutosLegais[] = []
    cpf: string = '';
    ListaIdPessoa: number[];
    isDateFormat: boolean = environment.isDateFormat;


    nrCpf: string;

    /** Whether the number of selected elements matches the total number of rows. */
    isAllSelected() {
        const numSelected = this.selection.selected.length;
        const numRows = this.dataSource.data.length;
        return numSelected === numRows;
    }

    /** Selects all rows if they are not all selected; otherwise clear selection. */
    masterToggle() {
        this.isAllSelected() ?
            this.selection.clear() :
            this.dataSource.data.forEach(row => this.selection.select(row));
    }

    /** The label for the checkbox on the passed row */
    checkboxLabel(row?: Filtro): string {
        if (!row) {
            return `${this.isAllSelected() ? 'select' : 'deselect'} all`;
        }
        return `${this.selection.isSelected(row) ? 'deselect' : 'select'} row ${row.id + row.idProcesso}`;
    }


    constructor(
        private readonly router: Router,
        private processoService: ProcessoService,
        private webProcessoInstitutosLegaisService: WebProcessoInstitutosLegaisService,
        private esteiraService: EsteiraService,
        private enviarEmailInstitutosLegaisService: EnviarEmailInstitutosLegaisService,
        private planoService: PlanoService,
        private webProcessoControleService: WebProcessoControleService,
        private _snackBar: MatSnackBar,
        private loginStore: LoginStore
    ) { }

    ngOnInit() {
        this.dataSource.paginator = this.paginator;
        this.loginStore.getCurrent().subscribe(retorno => {
            this.idPessoaLogada = retorno.idPessoa;
        });

        this.loadPlano();
        this.loadProcesso();
        this.loadEsteira();

        let obj = JSON.parse(localStorage.getItem('search'));

        if (obj != null) {
            this.selectedProcesso = obj.selectedProcesso;
            this.selectedMatricula = obj.selectedMatricula;
            this.selectedPlano = obj.selectedPlano;
            this.dataInicio = obj.dataInicio;
            this.dataFim = obj.dataFim;
            this.selectedOrderBy = obj.selectedOrderBy;
            // this.cpf = obj.cpf;
            // this.applyFilter(obj.cpf);
            this.filtroBuscaAdesao();
        }

    }
    loadPlano() {
        this.planoService.getAll().subscribe(plano => {
            this.lista_Plano = plano;
        })
    }

    loadProcesso() {
        this.processoService.getAll().subscribe(processo => {
            this.lista_Processo = processo;
        });
    }

    loadEsteira() {
        this.esteiraService.getAll().subscribe(esteira => {
            this.lista_Esteira = esteira;
        });
    }
    preencheTabela() {
        this.loading = true;
        this.viewModelFiltraProcessoInstitutosLegais.dtInicio = this.dataInicio;
        this.viewModelFiltraProcessoInstitutosLegais.dtFim = this.dataFim;
        this.viewModelFiltraProcessoInstitutosLegais.idPlano = this.selectedPlano;
        this.viewModelFiltraProcessoInstitutosLegais.nrCpf = this.cpf;

        if (this.dataInicio == undefined || this.dataInicio == null) {
            this.dataInicio = "1900-01-01";

        }
        if (this.dataFim == undefined || this.dataFim == null) {
            let dataAtual = new Date();
            var dia = dataAtual.getDate();
            var mes = dataAtual.getMonth() + 1;
            var ano = dataAtual.getFullYear();
            let dataFormatada = ano + "-" + (mes < 10 ? ('0' + mes) : mes) + "-" + (dia < 10 ? ('0' + dia) : dia);
            this.dataFim = dataFormatada;

        }


        this.webProcessoInstitutosLegaisService.postFiltroDesligados(this.viewModelFiltraProcessoInstitutosLegais).subscribe(tabela => {
            console.log('data fim', this.dataFim);
            console.log('data inicio', this.dataInicio);
            console.log('TESTE DA TABELA', tabela);
            this.viewModelGridProcessoInstitutosLegais = tabela['data']
            this.dataSource = new MatTableDataSource<ViewModelGridProcessoInstitutosLegais>(tabela);
            this.dataSource.paginator = this.paginator;

            this.loading = false;


        }, error => {
            this.openSnackBarError("Erro ao realizar a busca!" + error.error, 'X');
            this.loading = false;

        });

    }

    totalPendencia(element: Filtro) {

        if (element.status == 8) return 0;
        if (element.status == 0 || element.status >= 0 && element.status <= 4) return 1;
        if (element.status >= 5 && element.status <= 7) return 2;

        return 0;
    }

    clear() {
        this.selectedProcesso = undefined;
        this.selectedMatricula = undefined;
        this.selectedPlano = undefined;
        this.dataInicio = undefined;
        this.dataFim = undefined;
        //this.selectedOrderBy = undefined;
    }
    filtroBuscaAdesao() {
        // FILTRO ADESÃO
        this.loading = true;
        this.cpf = undefined;


        this.webProcessoInstitutosLegaisService.postFiltroDesligados(this.viewModelFiltraProcessoInstitutosLegais).subscribe(tabela => {
            this.GridProcessoInstitutosLegais = tabela;
            if (tabela) {
                console.log(tabela);
                this.dataSource = new MatTableDataSource<Filtro>();
                this.dataSource.paginator = this.paginator;

                this.loading = false;
            }

        }, error => {
            this.openSnackBarError("Erro ao realizar a busca!" + error.error, 'X');
            this.loading = false;
        });

    }


    applyFilter(filterValue: string) {
        filterValue = filterValue.trim(); // Remove whitespace
        filterValue = filterValue.toLowerCase(); // Datasource defaults to lowercase matches
        this.dataSource.filter = filterValue;
    }

    openSnackBar(message: string, action: string) {
        this._snackBar.open(message, action, {
            duration: 20000,
            panelClass: ['mat-toolbar', 'mat-success']
        });
    }

    Enviar() {
        this.listaIdPessoa = [];

        // Percorra os itens selecionados na tabela
        this.selection.selected.forEach(item => {
            // Verifique se o objeto viewModelGridProcessoInstitutosLegais está presente
                this.listaIdPessoa.push(item.idPessoa);
        });
        this.enviarEmailInstitutosLegaisService.enviarEmailInstitutosLegais(this.listaIdPessoa).subscribe(lista => {
            this.openSnackBar("E-mail enviado!", 'X');
        });
}

deferir() {
    this.loading = true;
    let dataAtual = new Date();
    var dia = dataAtual.getDate();
    var mes = dataAtual.getMonth() + 1;
    var ano = dataAtual.getFullYear();
    let dataFormatada = ano + "-" + (mes < 10 ? ('0' + mes) : mes) + "-" + (dia < 10 ? ('0' + dia) : dia);

    var date2 = new Date(dataFormatada);

    let listaProcesso: ViewModelFinalizaProcesso[] = [];

    this.selection.selected.forEach(element => {
        if (element.nomeSituacao == 'PENDENTE') {
            if (element.idProcesso == 50) {
                var data1 = element.dtCredito.substring(0, 10);
                var date1 = new Date(data1);

                if (date1 >= date2) {
                    console.log(element)
                    element.nomeSituacao = "DEFERIDO";
                    listaProcesso.push({
                        idContrato: element.idContrato === null ? 0 : element.idContrato,
                        idProcesso: element.idProcesso,
                        idSolicitacao: element.id,
                        idPessoaLogin: this.idPessoaLogada
                    });
                } else {
                    this.openSnackBar("Contrato referente ao CPF " + element.nrCpf + " não pôde ser deferido! Verifique a data de crédito!", 'X');
                }
            } else {
                console.log(element)
                element.nomeSituacao = "DEFERIDO";
                listaProcesso.push({
                    idContrato: 0,
                    idProcesso: element.idProcesso,
                    idSolicitacao: element.id,
                    idPessoaLogin: this.idPessoaLogada
                });
            }
        }
    })

    this.dataSource = new MatTableDataSource<Filtro>(this.dataSource.data);
    this.dataSource.paginator = this.paginator;
    if (listaProcesso.length > 0) {
        this.webProcessoControleService.DeferirProcessoLista(listaProcesso).subscribe(res => {


            this.loading = false;
            this.filtroBuscaAdesao();

        }, error => {
            this.openSnackBarError("Erro ao deferido o processo!" + error.error, 'X');
            this.loading = false;
        });
    } else {
        this.loading = false;
    }
}

}
